// Styles
import "./VSpacer.css";

// Utilities
import { createSimpleFunctional } from "../../util/index.js";
export const VSpacer = createSimpleFunctional('v-spacer', 'div', 'VSpacer');
//# sourceMappingURL=VSpacer.js.map